export default __webpack_public_path__ + "static/media/pic4.d179429a.webp";